import React, { useState, useEffect, Component } from "react";
import { API_URL } from "../../constants";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const OfferAcceptOrReject = () => {
  const [pageLoading, setPageLoading] = useState(true);
  const navigate = useNavigate();
  const [submitted, setSubmit] = useState(false);
  // const {responseMessage} = props;
  const [view, setView] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [rejectmodal, setRejectModal] = useState(false);
  const [candidateName, setCandidateName] = useState("");
  const [offerStatus, setOfferSuccess] = useState(false);
  const [offerAccepted, setAccepted] = useState(false);
  const [offerAcceptedMessage, setOfferAcceptedMessage] = useState("");
  const [rejectReasonmodal, setrejectReasonmodal] = useState(false);
  const [reason_of_rejection, setReason] = useState("");
  const [reasonBoxInvalid, setReasonBoxInvalid] = useState(false);
  const [rejectSubmit, SetRejectSubmit] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [signedOffer, setSignedOffer] = useState("");
  const [finalSubmit, setFinalSubmit] = useState(false);
  const [errors, setError] = useState({});

  const [formData, setFormData] = useState({
    location: "",
    status: "",
    sign: "",
  });

  const handleClose = (e) => {
    setIsModalOpen(false);
  };
  const handleCloseReject = (e) => {
    e.preventDefault();
    setRejectModal(false);
  };
  const { offer_id } = useParams();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleReject = () => {
    setRejectModal(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setRejectModal(false);
    setSubmit(false);
    setFormData((prevData) => ({
      ...prevData,
      location: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      file: "",
    }));
    setPreview("");
  };
  const handleCloseRejectReason = () => {
    setrejectReasonmodal(false);
  };
  const handleClosePreviewModal = () => {
    setPreviewModal(false);
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      const fileType = file.type; // File MIME type
      const validImageTypes = ["image/gif", "image/jpeg", "image/png"]; // Allowed types

      if (!validImageTypes.includes(fileType)) {
        event.target.value = ""; // Clear the file input
        setError({
          ...errors,
          file_sign_error: {
            status: true,
            message: "Only image files (GIF, JPEG, PNG) are allowed.",
          },
        });
        return; // Exit early
      }

      if (file.size <= 1024 * 1024) {
        // Correct condition: Check if file size is less than or equal to 1 MB
        setSelectedFile(file); // Update selected file state
        const updatedFormData = { ...formData, sign: file }; // Update formData
        setFormData(updatedFormData);
        setPreview(URL.createObjectURL(file)); // Set preview URL
      } else {
        setError({
          ...errors,
          file_sign_error: {
            status: true,
            message: "File size must be less than or equal to 1 MB.",
          },
        });
      }
    }
  };

  const handleSubmit = async (e, status) => {
    if (formData.location != "" && formData.sign != "") {
      e.preventDefault(); // Prevent the default form submission behavior
      setError({ ...errors, file_sign_error: { status: false, message: "" } });
      setSubmit(true);
      // Collecting the form data
      const data = new FormData();
      data.append("location", formData.location);
      data.append("OfferLetterStatus_185", status);
      data.append("SignImage", formData.sign);
      data.append("offer_id", offer_id);
      // Add location
      const response = await axios.post(
        `${API_URL}yucfnzgxrlwbgvfsntxb`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status) {
        setIsModalOpen(false);
        setPreviewModal(true);
        setSignedOffer(response?.data?.header);
      }
    } else {
      setError({
        ...errors,
        file_sign_error: {
          status: true,
          message: "Signature image and Current location required",
        },
      });
      e.preventDefault();
    }
  };

  const handleRejectSubmit = async (e) => {
    e.preventDefault();
    setSubmit(true);
    if (reason_of_rejection == "" || reason_of_rejection.length < 10) {
      setReasonBoxInvalid(true);
    } else {
      SetRejectSubmit(true);
      setReasonBoxInvalid(false);
      let data = {
        reason: reason_of_rejection,
        offer_id: offer_id,
      };
      // Add location
      const response = await axios.post(
        `${API_URL}yucfnzgxrlwbgvfsntxbrjt`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setrejectReasonmodal(false);
      fetchData(offer_id);
      navigate("/details-submitted");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleReasonChange = (e) => {
    const { name, value } = e.target;
    setReason(value);
    if (value.length > 0) {
      setReasonBoxInvalid(false);
    }
  };

  const handleAccept = async (e, status) => {
    e.preventDefault();
    setError({ ...errors, file_sign_error: { status: false, message: "" } });
    let data1 = new FormData();
    data1.append("location", formData.location);
    data1.append("OfferLetterStatus_185", status);
    data1.append("SignImage", formData.sign);
    setFinalSubmit(true);
    const response = await axios.post(
      `${API_URL}yucfnzgxrlwbgvfsntxb/${offer_id}`,
      data1,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    setOfferAcceptedMessage(response.data.msg);
    setFinalSubmit(false);
    setPreviewModal(false);
    navigate("/offer-accepted");
  };

  useEffect(() => {
    fetchData(offer_id);
  }, []);

  const fetchData = async (offer_id) => {
    try {
      const response = await axios.get(
        `${API_URL}yucfnzgxrlwbgvfsntxb/${offer_id}`
      );
      if (response?.data?.status == "success") {
        let html = response.data.header.replaceAll(
          '<img src="#emailDocSign#" style="width:100px;height: 50px;">',
          ""
        );
        html = html.replaceAll(
          '<img src="#emailDocSign#" style="width:100px;height: 50px;margin-left:80px;margin-bottom:-12px;">',
          ""
        );
        setView(html);
        setCandidateName(response?.data?.name);
        setOfferSuccess(true);
        setPageLoading(false);
      } else {
        setOfferSuccess(false);
        setAccepted(true);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error posting form data:", error);
    }
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    if (!offerStatus) {
      return (
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-10 offset-sm-1 expired-div mt-4">
              <p>Link Expired</p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div dangerouslySetInnerHTML={{ __html: view }}></div>
            </div>
          </div>
          <div className="row ">
            <div className="col-sm-12 text-end mb-5">
              <Button className="custom-btn mt-5 ms-3" onClick={handleReject}>
                Reject
              </Button>
              <Button
                className="custom-btn mt-5 ms-3"
                onClick={handleOpenModal}
              >
                Accept
              </Button>
            </div>

            {/* accept button model */}
            {/* <Modal show={isModalOpen} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <div className="ms-3">
                  <h5>{candidateName}</h5>
                </div>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="row">
                    <br />
                    <div className="col-sm-4 form-group">
                      <label className="form-label">
                        Current Location<span className="required">*</span>
                      </label>
                    </div>
                    <div className="col-sm-8 form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {preview && (
                      <>
                        <div className="col-sm-4 form-group"></div>
                        <div className="col-sm-8 form-group">
                          <img
                            src={preview}
                            alt="Preview"
                            style={{
                              width: "200px",
                              height: "150px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </>
                    )}

                    <div className="col-sm-4 form-group">
                      <label className="form-label">
                        Signature<span className="required">*</span>
                      </label>
                    </div>
                    <div className="col-sm-8 form-group">
                      <input
                        type="file"
                        accept="image/*"
                        required
                        onChange={handleFileChange}
                      />
                      <p className="text-center error">
                        {errors?.file_sign_error?.status && (
                          <span className="error">
                            {errors?.file_sign_error?.message}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      type="button"
                      onClick={handleCloseModal}
                      class="cancel-btn me-2"
                      aria-label="Close"
                    >
                      Cancel
                    </button>

                    <button
                      disabled={submitted ? true : false}
                      onClick={(e) => handleSubmit(e, 1276)}
                      type=""
                      className="custom-btn"
                    >
                      {submitted ? <FaSpinner class="sm-spinner" /> : "Preview"}
                    </button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal> */}
            <Modal 
  show={isModalOpen} 
  onHide={handleCloseModal}
  dialogClassName="modal-md"
  centered
>
  <div className="modal-content" style={{ borderRadius: '8px' }}>
    <div 
      className="modal-header" 
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px 8px 0 0',
        padding: '12px 16px'
      }}
    >
      <p style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>{candidateName}</p>
      <button 
        onClick={handleCloseModal}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#000',
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
          lineHeight: '1'
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
    <div className="modal-body p-2">
      <Form>
        <div className="row">
          <div className="col-sm-4 form-group">
            <label className="form-label">
              Current Location<span className="required">*</span>
            </label>
          </div>
          <div className="col-sm-8 form-group">
            <input
              type="text"
              className="form-control"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              required
              style={{ marginBottom: '16px' }}
            />
          </div>

          {preview && (
            <>
              <div className="col-sm-4 form-group"></div>
              <div className="col-sm-8 form-group">
                <img
                  src={preview}
                  alt="Preview"
                  style={{
                    width: "200px",
                    height: "150px",
                    objectFit: "cover",
                    marginBottom: '16px'
                  }}
                />
              </div>
            </>
          )}

          <div className="col-sm-4 form-group">
            <label className="form-label">
              Signature<span className="required">*</span>
            </label>
          </div>
          <div className="col-sm-8 form-group">
            <input
              type="file"
              accept="image/*"
              required
              onChange={handleFileChange}
              style={{ marginBottom: '8px' }}
            />
            {errors?.file_sign_error?.status && (
              <span className="error" style={{
                color: '#dc3545',
                fontSize: '0.875rem',
                marginTop: '0.25rem',
                display: 'block'
              }}>
                {errors?.file_sign_error?.message}
              </span>
            )}
          </div>
        </div>

        <div className="mt-2 mb-1" style={{
          padding: '2px 4px',
          display: 'flex',
          justifyContent: 'end',
          borderTop: '1px solid #f0f0f0',
          marginTop: '16px',
          paddingTop: '16px'
        }}>
          <button
            type="button"
            onClick={handleCloseModal}
            className="cancel-btn-sm me-1"
            aria-label="Close"
          >
            Cancel
          </button>
          <button
            disabled={submitted}
            onClick={(e) => handleSubmit(e, 1276)}
            className="custom-btn-sm"
          >
            {submitted ? <FaSpinner className="sm-spinner" /> : "Preview"}
          </button>
        </div>
      </Form>
    </div>
  </div>
</Modal>

            {/* reject button model */}
            {/* <Modal show={rejectmodal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <div className="ms-3 fw-bold">
                  <p  style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>Confirm</p>
                </div>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="row text-center">
                    <p>Are you sure, you want to reject the offer?</p>
                  </div>

                  <div className="text-end">
                    <button className="cancel-btn me-2" onClick={handleCloseReject}>
                      No
                    </button>
                    <button
                      className="custom-btn me-2 pull-right"
                      onClick={(e) => {
                        setRejectModal(false);
                        setrejectReasonmodal(true);
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal> */}
            <Modal 
  show={rejectmodal} 
  onHide={handleCloseModal}
  dialogClassName="modal-sm"
  centered
>
  <div className="modal-content" style={{ borderRadius: '8px' }}>
    <div 
      className="modal-header" 
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px 8px 0 0',
        padding: '12px 16px'
      }}
    >
      <p style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>Confirm</p>
      <button 
        onClick={handleCloseModal}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#000',
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
          lineHeight: '1'
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
    <div className="modal-body p-3">
      <div className="row text-center">
        <p>Are you sure, you want to reject the offer?</p>
      </div>
    </div>
    <div className="mt-2 mb-1" style={{
      padding: '2px 4px',
      display: 'flex',
      justifyContent: 'end',
    }}>
      <button 
        className="cancel-btn-sm me-1" 
        onClick={handleCloseReject}
      >
        No
      </button>
      <button
        className="custom-btn-sm"
        onClick={(e) => {
          setRejectModal(false);
          setrejectReasonmodal(true);
        }}
      >
        Yes
      </button>
    </div>
  </div>
</Modal>
            {/* rejection reason  model */}
            {/* <Modal show={rejectReasonmodal} onHide={handleCloseRejectReason}>
              <Modal.Header closeButton>
                <div className="ms-3">
                  <h5>
                    Reason Of Rejection<span className="required">*</span>
                  </h5>
                </div>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label className="form-label">Reason</label>
                        <textarea
                          onChange={handleReasonChange}
                          className={
                            reasonBoxInvalid
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="reason"
                          id="reason"
                        ></textarea>
                        {reasonBoxInvalid ? (
                          <span className="error">
                            This field is required min 10 character
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <div className="text-end">
                  <button
                    className="custom-btn me-2"
                    onClick={handleCloseRejectReason}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={rejectSubmit ? true : false}
                    className="custom-btn me-2 pull-right"
                    onClick={(e) => {
                      handleRejectSubmit(e);
                    }}
                  >
                    {rejectSubmit ? <FaSpinner class="sm-spinner" /> : "Reject"}
                  </button>
                </div>
              </Modal.Footer>
            </Modal> */}
            <Modal 
  show={rejectReasonmodal} 
  onHide={handleCloseRejectReason}
  dialogClassName="modal-md"
  centered
>
  <div className="modal-content" style={{ borderRadius: '8px' }}>
    <div 
      className="modal-header" 
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px 8px 0 0',
        padding: '12px 16px'
      }}
    >
      <p style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>
        Reason Of Rejection<span className="required">*</span>
      </p>
      <button 
        onClick={handleCloseRejectReason}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#000',
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
          lineHeight: '1'
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
    <div className="modal-body p-2">
      <Form>
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              {/* <label className="form-label">Reason</label> */}
              <textarea
                onChange={handleReasonChange}
                className={
                  reasonBoxInvalid
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="reason"
                id="reason"
                style={{ minHeight: '100px' }}
                placeholder="Enter Your Reason Here..."
              ></textarea>
              {reasonBoxInvalid && (
                <span className="error" style={{
                  color: '#dc3545',
                  fontSize: '0.875rem',
                  marginTop: '0.25rem',
                  display: 'block'
                }}>
                  This field is required min 10 character
                </span>
              )}
            </div>
          </div>
        </div>
      </Form>
    </div>
    <div className="mb-1" style={{
      padding: '6px 8px',
      display: 'flex',
      justifyContent: 'end',
      // borderTop: '1px solid #f0f0f0'
    }}>
      <button
        className="cancel-btn-sm me-1"
        onClick={handleCloseRejectReason}
      >
        Cancel
      </button>
      <button
        disabled={rejectSubmit}
        className="custom-btn-sm"
        onClick={(e) => {
          handleRejectSubmit(e);
        }}
      >
        {rejectSubmit ? <FaSpinner className="sm-spinner" /> : "Reject"}
      </button>
    </div>
  </div>
</Modal>
            {/* Offer Letter Preview  model */}
            <Modal
              size="lg"
              show={previewModal}
              onHide={handleClosePreviewModal}
            >
              <Form>
                <Modal.Header closeButton className="p-3">
                  <p  style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>Preview</p>
                </Modal.Header>
                <Modal.Body>
                  <div dangerouslySetInnerHTML={{ __html: signedOffer }}></div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="text-end">
                    <button
                      className="cancel-btn me-2"
                      onClick={handleClosePreviewModal}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={finalSubmit ? true : false}
                      className="custom-btn me-2 pull-right"
                      onClick={(e) => handleAccept(e, 1276)}
                    >
                      {finalSubmit ? (
                        <FaSpinner class="sm-spinner" />
                      ) : (
                        "Accept"
                      )}
                    </button>
                  </div>
                </Modal.Footer>
              </Form>
            </Modal>
          </div>
        </div>
      );
      // }
    }
  }
};
export default OfferAcceptOrReject;
